<div class="resume">
    <h3 class="resume__title">Resumen de tu compra</h3>

    <div class="resume__item" *ngFor="let item of planSelected; index as i">
        <h4 class="type">{{item.name}}</h4>
        <span class="price">${{item.priceDiscount.toLocaleString()}}</span>
        <button (click)='removeplan()' class="btn-delate"><span class="icon icon-close"></span></button>
    </div>

    <div class="resume__item" *ngFor="let item of aditionalProducts; index as i">
        <h4 class="type">{{item.name}}</h4>
        <span class="price">${{item.totalPrice.toLocaleString()}}</span>
        <button (click)='remove(i, item.quantity)' class="btn-delate"><span class="icon icon-close"></span></button>
    </div>

    <div class="resume__pay">
        <div class="text-box">
            <p class="total-heading">Total:</p>
            <span class="total">${{summary.toLocaleString()}}</span>
        </div>
        <button type="submit" class="button secondary rounded block mt-medium" (click)="openShoppingDialog()">Pagar</button>
    </div>
</div>